function fitLine(el, targetWidth, minPx, maxPx) {
  el.style.width = `${targetWidth}px`;
  let lo = minPx;
  let hi = maxPx;

  while (hi - lo > 0.25) {
    const mid = (lo + hi) / 2;
    el.style.fontSize = `${mid}px`;
    if (el.scrollWidth > targetWidth) {
      hi = mid;
    } else {
      lo = mid;
    }
  }

  el.style.fontSize = `${lo}px`;
}

function applyLogoSizes(title, sinceText, tagline, innerW, sincePx, compact) {
  sinceText.style.fontSize = `${sincePx}px`;
  fitLine(title, innerW, compact ? 6 : 4, sincePx * 2.8);
  const tagMin = compact ? sincePx * 0.82 : 3;
  const tagMax = sincePx * 1.12;
  fitLine(tagline, innerW, tagMin, tagMax);
}

function contentWidth(title, since, tagline) {
  return Math.ceil(Math.max(title.scrollWidth, since.offsetWidth, tagline.scrollWidth));
}

function getAvailableWidth(frame, shrinkWidth, pad, maxWidthCap) {
  if (shrinkWidth && frame.parentElement) {
    const parentStyle = getComputedStyle(frame.parentElement);
    const parentPad =
      parseFloat(parentStyle.paddingLeft) + parseFloat(parentStyle.paddingRight);
    const parentW = frame.parentElement.clientWidth - parentPad;
    const cap = Number.isFinite(maxWidthCap) ? maxWidthCap - pad : parentW;
    return Math.max(Math.min(parentW, cap), 120);
  }

  const frameInnerW = frame.clientWidth - pad;
  if (shrinkWidth) {
    const cap = Number.isFinite(maxWidthCap) ? maxWidthCap - pad : 256;
    return Math.max(Math.min(cap, frameInnerW > 0 ? frameInnerW : 256), 120);
  }

  return Math.max(frameInnerW, 120);
}

export function fitLogoFrame(frame, options = {}) {
  const { shrinkWidth = false, compact = false, autoHeight = false } = options;
  const box = frame.querySelector('.logo-box');
  const logo = frame.querySelector('.logo');
  if (!box || !logo) return;

  const title = logo.querySelector('.logo-title');
  const since = logo.querySelector('.logo-since');
  const sinceText = since.querySelector('.text');
  const tagline = logo.querySelector('.logo-tagline');

  const style = getComputedStyle(frame);
  const pad = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
  const padV = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
  const maxWidthCap = parseFloat(style.maxWidth) || Infinity;

  logo.style.transform = 'none';
  if (frame.style.width) {
    frame.style.width = '';
  }
  if (autoHeight && frame.style.height) {
    frame.style.height = '';
  }

  const sinceRatio = compact ? 0.052 : 0.048;
  const innerW = getAvailableWidth(frame, shrinkWidth, pad, maxWidthCap);

  if (autoHeight) {
    const sincePx = Math.max(compact ? 6 : 4, innerW * sinceRatio);
    applyLogoSizes(title, sinceText, tagline, innerW, sincePx, compact);

    if (shrinkWidth) {
      const fittedW = contentWidth(title, since, tagline);
      const boxWidth = `${fittedW}px`;
      const frameWidth = `${fittedW + pad}px`;
      if (box.style.width !== boxWidth) {
        box.style.width = boxWidth;
      }
      if (frame.style.width !== frameWidth) {
        frame.style.width = frameWidth;
      }
    } else {
      const boxWidth = `${innerW}px`;
      if (box.style.width !== boxWidth) {
        box.style.width = boxWidth;
      }
    }

    // Chrome flex layout can clip descenders unless height includes a small buffer.
    const chromeDescenderBuffer = 3;
    const minH = logo.offsetHeight + padV + chromeDescenderBuffer;
    const minHeight = `${minH}px`;
    if (frame.style.minHeight !== minHeight) {
      frame.style.minHeight = minHeight;
    }
    return;
  }

  const frameInnerW = frame.clientWidth - pad;
  const maxInnerW = shrinkWidth
    ? Math.min(Number.isFinite(maxWidthCap) ? maxWidthCap - pad : 256, frameInnerW > 0 ? frameInnerW : 256)
    : frameInnerW;
  const innerH = frame.clientHeight - padV;

  let lo = 0.25;
  let hi = 1;
  let best = lo;

  while (hi - lo > 0.008) {
    const mid = (lo + hi) / 2;
    const sincePx = Math.max(compact ? 6 : 4, innerW * sinceRatio * mid);
    applyLogoSizes(title, sinceText, tagline, innerW, sincePx, compact);

    if (logo.offsetHeight > innerH) {
      hi = mid;
    } else {
      best = mid;
      lo = mid;
    }
  }

  const sincePx = Math.max(compact ? 6 : 4, innerW * sinceRatio * best);
  applyLogoSizes(title, sinceText, tagline, innerW, sincePx, compact);

  if (shrinkWidth) {
    const fittedW = contentWidth(title, since, tagline);
    const boxWidth = `${fittedW}px`;
    const frameWidth = `${fittedW + pad}px`;
    if (box.style.width !== boxWidth) {
      box.style.width = boxWidth;
    }
    if (frame.style.width !== frameWidth) {
      frame.style.width = frameWidth;
    }
  } else {
    const boxWidth = `${maxInnerW}px`;
    if (box.style.width !== boxWidth) {
      box.style.width = boxWidth;
    }
  }
}
